import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UiLayoutState } from '@contracts/index';

const initialState: UiLayoutState = {
  sidebarOpen: true,
  activePanel: 'scene',
  showTimeline: true,
  splitViewEnabled: false,
  secondaryRunId: null,
  showDomainBox: true,
  cfdVisible: true,
  cfdDensity: 1.0,
  cfdGlyphScale: 1.0,
  flowPreviewActive: false
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setActivePanel: (state, action: PayloadAction<UiLayoutState['activePanel']>) => {
      state.activePanel = action.payload;
    },
    setShowTimeline: (state, action: PayloadAction<boolean>) => {
      state.showTimeline = action.payload;
    },
    setSplitViewEnabled: (state, action: PayloadAction<boolean>) => {
      state.splitViewEnabled = action.payload;
    },
    setSecondaryRunId: (state, action: PayloadAction<string | null>) => {
      state.secondaryRunId = action.payload;
    },
    setShowDomainBox: (state, action: PayloadAction<boolean>) => {
      state.showDomainBox = action.payload;
    },
    toggleDomainBox: (state) => {
      state.showDomainBox = !state.showDomainBox;
    },
    setCfdVisible: (state, action: PayloadAction<boolean>) => {
      state.cfdVisible = action.payload;
    },
    toggleCfdVisible: (state) => {
      state.cfdVisible = state.cfdVisible === undefined ? false : !state.cfdVisible;
    },
    setCfdDensity: (state, action: PayloadAction<number>) => {
      state.cfdDensity = action.payload;
    },
    setCfdGlyphScale: (state, action: PayloadAction<number>) => {
      state.cfdGlyphScale = action.payload;
    },
    setFlowPreviewActive: (state, action: PayloadAction<boolean>) => {
      state.flowPreviewActive = action.payload;
    },
    toggleFlowPreview: (state) => {
      state.flowPreviewActive = !state.flowPreviewActive;
    }
  }
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setActivePanel,
  setShowTimeline,
  setSplitViewEnabled,
  setSecondaryRunId,
  setShowDomainBox,
  toggleDomainBox,
  setCfdVisible,
  toggleCfdVisible,
  setCfdDensity,
  setCfdGlyphScale,
  setFlowPreviewActive,
  toggleFlowPreview
} = uiSlice.actions;

export default uiSlice.reducer;
